// Dates and times leave the browser in one fixed format (YYYY-MM-DD / HH:mm:ss)
// regardless of the visitor's locale, so the API and Postgres always parse them.
const pad = (num) => String(num).padStart(2, '0')

export const toDateKey = (date) => {
    if (!date) {
        return ''
    }
    return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`
}

export const toTimeKey = (date) => {
    if (!date) {
        return ''
    }
    return `${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`
}

// Parse in local time — new Date('YYYY-MM-DD') is read as UTC and can land on the previous day.
export const fromDateKey = (key) => {
    const match = typeof key === 'string' ? key.match(/^(\d{4})-(\d{2})-(\d{2})/) : null
    if (!match) {
        return null
    }
    return new Date(Number(match[1]), Number(match[2]) - 1, Number(match[3]))
}

export const fromTimeKey = (key) => {
    const match = typeof key === 'string' ? key.match(/^(\d{2}):(\d{2})(?::(\d{2}))?$/) : null
    if (!match) {
        return null
    }
    const date = new Date()
    date.setHours(Number(match[1]), Number(match[2]), Number(match[3] || 0), 0)
    return date
}

export const displayDateKey = (key) => {
    const date = fromDateKey(key)
    return date ? date.toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' }) : ''
}
